export default __webpack_public_path__ + "bcf65de5d6777b189162e5813adc0d33.svg";